// Module
var code = "<salary-table :data=\"stuff_list\" :loading=\"loading\"> </salary-table> ";
// Exports
module.exports = code;